import { api } from "./api";

export const visitorsList = async (params: unknown): Promise<any> => {
  const { data } = await api.get("visitor", { params });
  return data;
};

export const visitorsListById = async (id: number | string): Promise<any> => {
  const { data } = await api.get("visitor/" + id);
  return data;
};

export const visitorCreate = async (body: any): Promise<any> => {
  const { data } = await api.post("visitor", body);
  return data;
};

export const visitorUpdate = async (
  id: number | string,
  body: any
): Promise<any> => {
  const { data } = await api.put("visitor/" + id, body);
  return data;
};

export const visitorDelete = async (id: string | number): Promise<any> => {
  const { data } = await api.delete("visitor/" + id);
  return data;
};
